import React from "react";

import "./ConversationTableFooterGuide.scss";

//i18n
import { withTranslation } from "react-i18next";

const index = ({ t, ...props }) => {
  return (
    <div className="d-flex justify-content-between mt-3 mr-4">
      <span id="current-conversations-number" className="text-dark">
        {(props.pageConversationsNumber - 1) * props.qtdConversationsNumber + 1}
        {" - "}
        {props.pageConversationsNumber * props.qtdConversationsNumber <
        props.totalConversationsNumber
          ? props.pageConversationsNumber * props.qtdConversationsNumber
          : props.totalConversationsNumber}
      </span>
      {t("of")}
      <span id="total-conversations-number" className="text-dark">
        {props.totalConversationsNumber}
      </span>
      {t("chats")}
    </div>
  );
};

export default withTranslation()(index);
